export default __webpack_public_path__ + "static/media/bg_team.77cdcfa8.png";